import { createStore, createLogger } from "vuex";

export default function initializeStore( { environment, disableVuexLogging, } ) {
	const plugins = [];

	if ( [ "development", "test", ].includes( environment ) ) {
		if ( !disableVuexLogging ) {
			// @see https://next.vuex.vuejs.org/guide/plugins.html#built-in-logger-plugin
			plugins.push( createLogger() );
		}
	}

	return createStore( {
		state: {},
		mutations: {},
		actions: {},
		modules: {},
		plugins,
	} );
}
